import React from 'react';
import AddBudgetSurrenderComponent from '../../components/BudgetSurrender/AddBudgetSurrender';


export default function AddBudgetSurrenderPage() {
    return (
        <div>
          {<AddBudgetSurrenderComponent />}
        </div>
      )
}